module.exports = __webpack_public_path__ + "img/private_event_green.c5ab1c6f.jpg";